
import { useQuery } from "@tanstack/react-query";
import { getPublicPetsByCategory } from "../services/categoryService";
import { getMultiplePublicProfiles } from "../services/secureProfileService";

export function usePublicPetsByCategoryWithOwners(category?: string) {
  return useQuery({
    queryKey: ["public-pets-with-owners", category],
    queryFn: async () => {
      // Paso 1: obtener pets públicos por categoría
      const pets = await getPublicPetsByCategory(category);
      const list = (pets as any[]) || [];

      // Paso 2: recolectar user_ids únicos
      const userIds = Array.from(
        new Set(
          list
            .map((p: any) => p?.user_id)
            .filter((id: string | null | undefined): id is string => Boolean(id))
        )
      );

      // Paso 3: obtener perfiles públicos seguros
      let profilesMap = new Map<string, any>();
      if (userIds.length > 0) {
        const profiles = await getMultiplePublicProfiles(userIds);
        profilesMap = new Map(profiles.map((p: any) => [p.id, p]));
      }

      // Paso 4: enriquecer cada pet con "users" (para mantener compatibilidad con la vista)
      const enriched = list.map((pet: any) => ({
        ...pet,
        users: pet?.users ?? profilesMap.get(pet?.user_id) ?? null,
      }));

      return enriched;
    },
  });
}

export default usePublicPetsByCategoryWithOwners;
